module.exports = __webpack_public_path__ + "static/media/b5.f365542c.webp";